//theme zendesk garden
import { ThemeProvider } from "@zendeskgarden/react-theming";

import Router from "./routes/router";
import { Header } from "@atoms";

const App = () => {
  return (
    <ThemeProvider>
      <Header />
      <Router />
    </ThemeProvider>
  );
};

export default App;
